// The resume lives in Google Drive so it can be updated without a redeploy:
// upload a new version of the same Drive file and this link keeps working.
export const RESUME_URL = 'https://drive.google.com/file/d/17ZHmmTGhK2wNZsoe-3zaryvZ9_7hiaBF/view';
export const GITHUB_URL = 'https://github.com/rileycleavenger';
export const LINKEDIN_URL = 'https://www.linkedin.com/in/rileycleavenger/';
